const EMBED_SERVICES = {
  Twitter: {
    screenname: 'X',
    sloganname: 'X-Post',
    callback: function( element, url, disclaimer ) {
      element.addClass( 'twitter-embed' );
      window.twttr = (
        function( d, s, id ) {
          let js;
          let fjs = d.getElementsByTagName( s )[0];
          let t = window.twttr || {};
          if ( d.getElementById( id ) ) {
            return t;
          }
          js = d.createElement( s );
          js.id = id;
          js.src = 'https://platform.twitter.com/widgets.js';
          fjs.parentNode.insertBefore( js, fjs );
          t._e = [];
          t.ready = function( f ) {
            t._e.push( f );
          };
          return t;
        }( document, 'script', 'twitter-wjs' )
      );

      window.twttr.ready( () => {
        const el = $( element );
        window.twttr.widgets.createTweet( url.replace( /.*\/(.*?)/, '$1' ), el.get( 0 ) ).then( () => {
          el.append( disclaimer );
        } );
      } );
    }
  },
  Facebook: {
    screenname: 'Facebook',
    sloganname: 'Facebook-Post',
    callback: function( element, url, disclaimer, config ) {
      element.addClass( 'facebook-embed' );
      let embed = '';
      if ( config.embed_type === 'post' ) {
        embed = '<div style="min-height: 400px" class="fb-post fb-embed fb_iframe_widget_fluid_desktop" data-width="640" data-href="' + url + '" data-show-text="' + config['show-text'] + '"></div>';
      }
      if ( config.embed_type === 'video' ) {
        embed = '<div class="fb-video fb-embed" data-href="' + url + '" data-autoplay="' + config.autoplay + '" data-allowfullscreen="' + config.allowfullscreen + '"></div>';
      }
      if ( embed !== '' ) {
        (
          function( d, s, id ) {
            let js;
            let fjs = d.getElementsByTagName( s )[0];
            if ( d.getElementById( id ) ) {
              return;
            }
            js = d.createElement( s );
            js.id = id;
            js.src = 'https://connect.facebook.net/de_DE/sdk.js#xfbml=1&version=v7.0';
            fjs.parentNode.insertBefore( js, fjs );
          }( document, 'script', 'facebook-jssdk' )
        );

        element.append( embed );
        element.append( disclaimer );
      }
    }
  },
  Youtube: {
    screenname: 'Youtube',
    sloganname: 'Youtube-Video',
    callback: function( element, url, disclaimer ) {
      element.addClass( 'youtube-embed' );
      const width = element.width();
      let newUrl = url.replace( /youtube.com/, 'youtube-nocookie.com' );
      if ( newUrl.indexOf( 'youtube-nocookie.com' ) === -1 ) {
        newUrl = url.replace( /youtu.be/, 'youtube-nocookie.com/embed' );
        if ( newUrl.indexOf( 'www.' ) === -1 ) {
          newUrl = newUrl.replace( 'https://', 'https://www.' )
        }
        newUrl = newUrl.replace( /\?si.*/, '' );
      } else {
        if ( newUrl.match( /embed/ ) === null ) {
          newUrl = 'https://www.youtube-nocookie.com/embed/' + newUrl.replace( /.*v=/, '' );
        }
      }

      element.append( '<div class=ytwrapper><iframe width="' + width + '" height="' + width * 9 / 16 + '" src="' + newUrl + '?rel=0" frameborder="0" allowfullscreen></iframe></div>' );
      element.append( disclaimer );
    }
  },
  Instagram: {
    screenname: 'Instagram',
    sloganname: 'Instagram-Post',
    callback: function( element, url, disclaimer ) {
      element.addClass( 'instagram-embed' );
      window.consenter.loadJS( 'insta_embed', 'https://platform.instagram.com/de_DE/embeds.js' );
      window.consenter.addAfterLoadCallback( 'insta_embed', () => {
        const embedstring = '<blockquote class="instagram-media" data-instgrm-version="14" data-instgrm-permalink="' + url + '" style="background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:658px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><a href="' + url + '" target="_blank"></a></blockquote>';
        element.prepend( embedstring );
        window.instgrm.Embeds.process();
        element.append( disclaimer );
      } );
    }
  },
  Tiktok: {
    screenname: 'TikTok',
    sloganname: 'TikTok-Video',
    callback: function( element, url, disclaimer ) {
      element.addClass( 'tiktok-embed' );
      const embedUrl = 'https://www.tiktok.com/oembed?url=' + url;
      fetch( embedUrl )
        .then( response => {
          if ( !response.ok ) {
            throw new Error( 'Network response was not ok' );
          }
          return response.json();
        } )
        .then( myJson => {
          element.prepend( myJson.html );
          element.append( disclaimer );
        } )
        .catch( error => {
          console.error( 'There has been a problem with your fetch operation:', error ); // eslint-disable-line no-console
        } );
    }
  },
  Glomex: {
    screenname: 'Glomex',
    sloganname: 'Glomex-Video',
    callback: function( element, url, disclaimer, config ) {
      element.addClass( 'instagram-embed' );
      const splitted = url.split( '?integrationId=' );
      let integrationId = '';
      if ( splitted.length > 1 ) {
        integrationId = splitted[1];
      } else {
        integrationId = '40599v1wla6tk11u';
      }
      window.consenter.waitForCmpPref( window.tcfApiConsentAdapter.UTOPIA_PURPOSES.ANALYTICS, () => {
        window.consenter.loadJS( 'glomex', 'https://player.glomex.com/integration/1/glomex-player.js' );
        element.prepend( `
            <glomex-player
              data-integration-id="${integrationId}"
              data-playlist-id="${splitted[0].replace( 'https://exchange.glomex.com/video/', '' )}">
            </glomex-player>
            ` );
      } );
    }
  },
  Opinary: {
    screenname: 'Opinary',
    sloganname: 'Opinary-Poll',
    callback: function( element, url, disclaimer, config ) {
      element.addClass( 'instagram-embed' );
      window.consenter.waitForCmpPref( window.tcfApiConsentAdapter.UTOPIA_PURPOSES.ANALYTICS, () => {
        element.prepend( `
            <div class="opinary-widget-embed" data-poll="${config.poll}" data-customer="${config.customer}"></div>
            ` );
        window.consenter.loadJS( 'opinary', '//widgets.opinary.com/embed.js' );
      } );
    }
  },
  DAA: {
    screenname: 'DAA',
    sloganname: 'DAA-Widget',
    callback: function( element, url, disclaimer, config ) {
      let embed = '<daa-wgt data-itg="' + config.id + '"></daa-wgt><script async src="https://hub.daa.net/js/hub.js"></script>';
      if ( embed !== '' ) {
        element.append( embed );
        element.append( disclaimer );
      }
    }
  },
  Internal: {
    screenname: 'Internal',
    sloganname: 'Interner Link',
    callback: function( element, url, disclaimer, config ) {
      let embed = `
        <div>
        <a title="${config.title}" href="${url}" class="ana_embed_ut_link_internal">
        <div class="teaser link-embed alignleft mb20">
        <figure class="" data-attachment-id="${config.attachmentId}">
        <div class="aspect ratio-15-7">
            <img loading="lazy" fetchpriority="high" decoding="async" class="utimgrszr" width="360" height="169" src="${config.imgSrc}" title="${config.imgTitle}" alt="${config.imgAlt}">
        </div>
      <figcaption>${config.imgCaption}</figcaption></figure> <div class="h3">
        ${config.title}</div>
      <div class="content">
        <p class="copy fs14 mb5">${config.description}</p>
        <p class="txt-right mb10"><span class="link-bb">Weiterlesen</span></p>
      </div>
    </div>
    </a>
    </div>
    `;
      if ( embed !== '' ) {
        element.append( embed );
      }
    }
  }, Podigee: {
    screenname: 'Podigee',
    sloganname: 'Podigee',
    callback: function( element, url, disclaimer, config ) {
      const queryParam = "/embed?context=external";
      let embed = `<div class="ut-podcast"><script class="podigee-podcast-player"
          src="https://cdn.podigee.com/podcast-player/javascripts/podigee-podcast-player.js"
          data-configuration="${url}${queryParam}"></script></div>`;

      if ( embed !== '' ) {
        element.append( embed );
      }
    }
  }, Recipe: {
    screenname: 'Rezepte',
    sloganname: 'Rezepte Embed',
    callback: function( element, url, disclaimer, config ) {
      let embed = `
        <div>
        <a title="${config.title}" href="${url}" class="ana_embed_ut_link_recipe">
        <div class="teaser link-embed alignleft mb20">
        <figure>
        <div class="aspect ratio-15-7">
            <img loading="lazy" fetchpriority="high" decoding="async" class="utimgrszr" width="360" height="169" src="${config.imgSrc}" title="${config.imgTitle}" alt="${config.imgAlt}">
        </div>
      <figcaption>${config.imgCaption}</figcaption></figure> <div class="h3">
        ${config.title}</div>
      <div class="content">
        <p class="copy fs14 mb5">${config.description}</p>
        <p class="txt-right mb10"><span class="link-bb">Weiterlesen</span></p>
      </div>
    </div>
    </a>
    </div>
    `;
      if ( embed !== '' ) {
        element.append( embed );
      }
    }
  }
};
export default EMBED_SERVICES;
